import { SharedService } from './../../shared/shared.service';
import { endpoints } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ExtractAccount } from './models/extract-account';
import { Record } from './models/record';
import * as moment from 'moment';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import { Observable } from 'rxjs';
import { BaseResult } from '../../shared/models/base.result.model';
import { BankExtract, TransactionType } from './extract.model';

@Injectable()
export class ExtractService {
	public static EXTRACT_15_DAYS_KEY = 'OmniExtractRecords';
	public extract: ExtractAccount;
	private url = endpoints.bankStatement;

	constructor(private http: HttpClient, private sharedService: SharedService) {}

	getExtractPix(dataInicial: string, dataFinal: string, detalhado: boolean): Observable<BaseResult<BankExtract>> {
		this.sharedService.dateBegin = moment(dataInicial).format('YYYY-MM-DD');
		this.sharedService.dateEnd = dataFinal ? moment(dataFinal).format('YYYY-MM-DD') : null;
		const url = dataFinal ?
			`${this.url.pix}?dataInicial=${dataInicial}&dataFinal=${dataFinal}&detalhado=${detalhado}` :
			`${this.url.pix}?dataInicial=${dataInicial}&detalhado=${detalhado}`;

		return this.http.get<BaseResult<BankExtract>>(url);
	}

	getNewExtract(dataInicial: string, dataFinal: string, detalhado: boolean): Observable<BaseResult<BankExtract>> {
		this.sharedService.dateBegin = moment(dataInicial).format('YYYY-MM-DD');
		this.sharedService.dateEnd = dataFinal ? moment(dataFinal).format('YYYY-MM-DD') : null;
		const url = dataFinal ?
			`${this.url.general}?dataInicial=${dataInicial}&dataFinal=${dataFinal}&detalhado=${detalhado}` :
			`${this.url.general}?dataInicial=${dataInicial}&detalhado=${detalhado}`;

		return this.http.get<BaseResult<BankExtract>>(url);
	}

	convertModelToView(retorno: BankExtract): Record[] {
		const records: Array<Record> = [];

		retorno.transacoes.forEach((o, index) => {

			const record = new Record();
			record.date = o.dataContabil;
			record.dateHour = o.dataTransacao;
			record.description = o.descricaoHistorico;
			record.mode = o.tipoMovimentacao;
			record.value = o.valor;
			record.hasBalance = false;
			record.transactionType = o.tipoTransacao;
			record.isPix = this.isTransactionPix(record);
			record.isPixDevolution = this.isTransactionPixDevolution(record);
			if(o.transacaoPix){
				record.pixOpenFinance = (Boolean)(o.transacaoPix.iniciadorCNPJ);
				record.isInfration = (Boolean)(o.transacaoPix.medResultadoAnalise && o.transacaoPix.medValorSolicitado);
			}

			if(record.isPix){
				record.devSpecialMecan =
				(Boolean)(o.transacaoPix.medResultadoAnalise
									&& o.transacaoPix.medValorSolicitado
									&& o.transacaoPix.medDetalhes);
			}

			if(record.isPix && o.transacaoPix.tipoOperacao){
				record.operationType = o.transacaoPix.tipoOperacao;
			}

			if (record.mode === 'D' && record.value >= 0) {
				record.value = record.value * -1;
			}

			// Adicionar as linhas de saldo do dia
			if (index === 0) {

				const saldoDia = new Record();
				saldoDia.date = record.date;
				saldoDia.hasBalance = true;
				saldoDia.balance = o.saldo;
				saldoDia.name = 'saldo do dia';

				records.push(saldoDia);

			} else if (index < retorno.transacoes.length) {

				if (record.date !== retorno.transacoes[index - 1].dataContabil) {

					const saldoDia = new Record();
					saldoDia.date = record.date;
					saldoDia.hasBalance = true;
					saldoDia.balance = o.saldo;
					saldoDia.name = 'saldo do dia';

					records.push(saldoDia);
				}
			}

			records.push(record);
		});

		return records;
	}

	isTransactionPix(record: Record): boolean {
		return (
			record.transactionType === TransactionType.PIX_DEVOLUCAO_ENVIADA ||
			record.transactionType === TransactionType.PIX_DEVOLUCAO_RECEBIDA ||
			record.transactionType === TransactionType.PIX_ENVIADO ||
			record.transactionType === TransactionType.PIX_RECEBIDO
		);
	}

	isTransactionPixDevolution(record: Record): boolean {
		return record.transactionType === TransactionType.PIX_DEVOLUCAO_ENVIADA || record.transactionType === TransactionType.PIX_DEVOLUCAO_RECEBIDA;
	}

	getExtract(dateBegin: any, dateEnd: any, filterByPeriod: Boolean, handler: any, reverse: boolean = false) {

		const beginDate = moment(dateBegin).format('YYYY-MM-DD');
		const endDate = moment(dateEnd).format('YYYY-MM-DD');
		const params = new HttpParams()
			.set('dataIni', beginDate)
			.set('dataFim', endDate);

		this.sharedService.dateBegin = beginDate;
		this.sharedService.dateEnd = endDate;

		this.http.get(endpoints.accounts.releases, { params }).subscribe( (data: any) => {
			if (data.Sucesso) {
				this.extract = new ExtractAccount();

				if (data.Retorno.Lancamentos.length > 0) {
					if (reverse) {
						data.Retorno.Lancamentos = data.Retorno.Lancamentos.reverse();
					}

					const records: Array<Record> = [];

					for ( let i = 0; i < data.Retorno.Lancamentos.length; i++) {
						const record = new Record();
						record.date = data.Retorno.Lancamentos[i].DataLancamento;
						record.name = data.Retorno.Lancamentos[i].title;
						record.description = data.Retorno.Lancamentos[i].DescricaoCompleta;
						record.mode = data.Retorno.Lancamentos[i].Modalidade;
						record.value = data.Retorno.Lancamentos[i].Valor;
						record.hasBalance = false;

						if (record.mode === 'D' && record.value >= 0) {
							record.value = record.value * -1;
						}

						if (i === 0) {
							const saldoDia = new Record();
							saldoDia.date = record.date;
							saldoDia.hasBalance = true;
							saldoDia.balance = data.Retorno.Lancamentos[i].Saldo;
							saldoDia.name = 'saldo do dia';

							records.push(saldoDia);
						}

						records.push(record);

						if (i !== 0 && i < data.Retorno.Lancamentos.length) {
							const extDia = data.Retorno.Lancamentos.filter(l => l.DataLancamento === record.date);
							const rec = records.find((r) => r.date === record.date && r.hasBalance);

							if (rec) {
								rec.balance = extDia[reverse ? 0 : extDia.length - 1].Saldo;
							}

							if (i + 1 < data.Retorno.Lancamentos.length && record.date !== data.Retorno.Lancamentos[i + 1].DataLancamento) {
								const saldoDia = new Record();
								saldoDia.date = data.Retorno.Lancamentos[i + 1].DataLancamento;
								saldoDia.hasBalance = true;
								saldoDia.name = 'saldo do dia';

								records.push(saldoDia);
							}
						}
					}

					this.extract.records = records;
				}

			}

			handler(this.extract);

		}, (httpErrorResponse) => {

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: httpErrorResponse.error.Mensagem});

			this.extract = new ExtractAccount();

			handler(this.extract);
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/extract/extract.service.ts